import { ReducerActionRotaSP } from 'store/modules/types';

import { ExcluirParametrosLocalidadeRequest, Types } from './types';

export function excluirParametrosLocalidadeRequest(
	token: string,
	data: ExcluirParametrosLocalidadeRequest,
): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_PARAMETROS_LOCALIDADE,
		token,
		payload: {
			sigla: data.sigla,
			// idOrgao: data.idOrgao,
		},
	};
}
export function excluirParametrosLocalidadeSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_PARAMETROS_LOCALIDADE_SUCCESS,
		payload,
	};
}
export function excluirParametrosLocalidadeFailure(): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_PARAMETROS_LOCALIDADE_FAILURE,
		payload: null,
	};
}
export function excluirParametrosLocalidadeClear(): ReducerActionRotaSP {
	return {
		type: Types.EXCLUIR_PARAMETROS_LOCALIDADE_CLEAR,
		payload: null,
	};
}
